import { render, staticRenderFns } from "./LimitsTemplates.vue?vue&type=template&id=0292a054&"
import script from "./LimitsTemplates.vue?vue&type=script&lang=js&"
export * from "./LimitsTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports